import { ReduxFormConstants } from '../constants/actions';

export const untouchAll = form => ({
  type: `${ReduxFormConstants.UNTOUCH_ALL}`,
  formToChange: form
});
